import React from "react";

import { Skeleton } from "@common/skeleton";
import styles from "./styles.scss";

function Loader() {
  return (
    <div className={styles.loader}>
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className={styles.item}>
          <Skeleton className={styles.avatar} />
          <Skeleton className={styles.name} />
        </div>
      ))}
    </div>
  );
}

export { Loader };
